var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"xksCascader"}},[_c('el-cascader',{staticClass:"cascader",attrs:{"placeholder":"请选择省市信息","size":"small","options":_vm.options,"props":_vm.props,"show-all-levels":_vm.is_levels,"clearable":""},on:{"change":_vm.onChange},model:{value:(_vm.innerCity),callback:function ($$v) {_vm.innerCity=$$v},expression:"innerCity"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }